module.exports = __webpack_public_path__ + "img/menu-item-light@2x.3c38acaf.png";